(function() {
'use strict';

angular.module('dashboard').controller('OnlineCheckin', OnlineCheckin);

function OnlineCheckin(onlineCheckinService, arrayUtil, $routeParams, $scope, resourceService, $rootScope, dashboardBookingService) {
    const cm = this;
    cm.legs = [];
    cm.SupplierConditionsList = [];
    cm.bookingId = $routeParams.bookingId;
    cm.checkinSelected = false;
    cm.loadingCheckinOptions = true;
    cm.checkinInProgress = false;
    cm.checkinError = false;
    cm.showProceedBtn = false;
    cm.checkedInLegs = 0;
    cm.legCheckinAllSelected = legCheckinAllSelected;
    cm.printBoardingPass = printBoardingPass;
    cm.doCheckin = doCheckin;

    $rootScope.lockScreen($scope, {
        title: resourceService.get('ONLINECHECKIN_FETCHINGCHECKININFO'),
        subtitle: resourceService.get('THISMAYTAKE'),
        loadingScreenStyle: 'default-onlineCheckinCtrl'
    });

    dashboardBookingService.getBookingInfo($routeParams.bookingId).then(function(booking) {
        cm.booking = booking;
    });

    onlineCheckinService.getOnlineCheckinOptions(cm.bookingId).then(function(result) {
        cm.loadingCheckinOptions = false;
        $rootScope.unlockScreen($scope);
        cm.bookingRef = result.BookingRef;
        cm.leadPassengerLastname = result.LeadPassengerLastName;
        angular.forEach(result.Legs, function(leg) {
            leg.checkinAll = false;
            leg.showSeatWarning = false;
            if (leg.CheckinState === 'Available') {
                cm.showProceedBtn = true;
                leg.checkinAll = true;
                if (leg.SupplierConditions) {
                    _formatSupplierConditions(leg.SupplierConditions, leg.LegType);
                }
            } else if (leg.CheckinState === 'CheckedIn') {
                cm.checkedInLegs++;
            }
            angular.forEach(leg.Passengers, function(passenger) {
                if (passenger.OptionalCharges) {
                    passenger.OptionalCharges[0].Quantity = null;
                    const maxQuantity = passenger.OptionalCharges[0].MaximumQuantity;
                    if (maxQuantity > 0) {
                        passenger.showBaggageSelection = true;
                        passenger.maxBags = arrayUtil.numberArray(0, passenger.OptionalCharges[0].MaximumQuantity);
                    }
                }
                if (passenger.SeatSelections) {
                    passenger.seats = passenger.SeatSelections.join(', ');
                } else {
                    leg.showSeatWarning = true;
                }
            });
            cm.checkinSelected = cm.checkinSelected || leg.checkinAll;
        });
        if (result.Legs) {
            cm.legs = result.Legs;
        }
    });

    function _formatSupplierConditions(conditions, legType) {
        const supplierConditions = { header: '', text: [] };
        supplierConditions.header = legType.toLowerCase();
        if (conditions.indexOf('\n') !== -1) {
            supplierConditions.text = conditions.split('\n');
            supplierConditions.text.pop();
        } else {
            supplierConditions.text[0] = conditions;
        }
        cm.SupplierConditionsList.push(supplierConditions);
    }
    cm.showBagsError = false;
    function doCheckin() {
        if (!cm.checkinSelected) {
            return false;
        }
        const legsToCheckin = arrayUtil.filter(cm.legs, function(leg) {
            return leg.checkinAll;
        });
        angular.forEach(legsToCheckin, function(leg) {
            angular.forEach(leg.Passengers, function(passenger) {
                if (passenger.OptionalCharges) {
                    if (passenger.OptionalCharges[0].Quantity === null) {
                        cm.showBagsError = true;
                    }
                }
            });
        });
        if (cm.showBagsError) {
            return false;
        }
        cm.checkinInProgress = true;
        onlineCheckinService.doCheckin(cm.bookingId, legsToCheckin).then(function(data) {
            cm.checkinInProgress = false;
            if (data.Result === 'Success') {
                angular.forEach(legsToCheckin, function(leg) {
                    leg.CheckinState = 'CheckedIn';
                    onlineCheckinService.getCheckinType(leg);
                    leg.checkinAll = false;
                    legCheckinAllSelected();
                });
            } else {
                cm.checkinError = true;
            }
        });
    }

    function legCheckinAllSelected() {
        cm.showBagsError = false;
        cm.checkinSelected = false;
        angular.forEach(cm.legs, function(leg) {
            cm.checkinSelected = cm.checkinSelected || leg.checkinAll;
        });
    }

    function printBoardingPass(leg) {
        window.open(`/api2/flightscheckin/boardingpass?bookingId=${cm.bookingId}&leg=${leg.LegType}`, '', 'width=768, height=700, location=no');
    }
}
})();
